export default __webpack_public_path__ + "static/media/temp.9d21514e.svg";